export enum ROLES {
  CLIENT = 'client',
  OWNER = 'owner',
  GUEST = 'guest',
  OWNER_AND_CLIENT = 'owner_and_client',
}
